import { RugbyContestant } from 'src/types/matchControl/contestant';

import AdjustButton from '../../components/AdjustButton';

type EventButtonProps = {
  label: string;
  value: number;
  count: number;
  onAdd: () => void;
  onRemove: () => void;
};

const ScoringEventButton = ({ label, value, count, onAdd, onRemove }: EventButtonProps) => (
  <div className="flex flex-row gap-2 items-center w-full">
    <div className="text-sm font-semibold flex-1 truncate">{label}</div>
    <div className="text-sm text-gray-500 whitespace-nowrap">{value} pts</div>
    <div className="text-sm font-semibold min-w-[1.5rem] text-center">{count}</div>
    <AdjustButton isSquare icon="minus" onClick={onRemove} disabled={count === 0} />
    <AdjustButton isSquare icon="plus" onClick={onAdd} />
  </div>
);

type Props = {
  contestant: RugbyContestant;
  onAddTry: () => void;
  onRemoveTry: () => void;
  onAddConversion: () => void;
  onRemoveConversion: () => void;
  onAddPenaltyKick: () => void;
  onRemovePenaltyKick: () => void;
  onAddDropGoal: () => void;
  onRemoveDropGoal: () => void;
};

const RugbyScoringEvents = ({
  contestant,
  onAddTry,
  onRemoveTry,
  onAddConversion,
  onRemoveConversion,
  onAddPenaltyKick,
  onRemovePenaltyKick,
  onAddDropGoal,
  onRemoveDropGoal,
}: Props) => (
  <div className="flex flex-col gap-2 w-full">
    <ScoringEventButton
      label="Try"
      value={5}
      count={contestant.score.tries}
      onAdd={onAddTry}
      onRemove={onRemoveTry}
    />
    <ScoringEventButton
      label="Conversion"
      value={2}
      count={contestant.score.conversions}
      onAdd={onAddConversion}
      onRemove={onRemoveConversion}
    />
    <ScoringEventButton
      label="Penalty"
      value={3}
      count={contestant.score.penaltyKicks}
      onAdd={onAddPenaltyKick}
      onRemove={onRemovePenaltyKick}
    />
    <ScoringEventButton
      label="Drop Goal"
      value={3}
      count={contestant.score.dropGoals}
      onAdd={onAddDropGoal}
      onRemove={onRemoveDropGoal}
    />
  </div>
);

export default RugbyScoringEvents;
